import type { ReactNode } from 'react'

import { cn } from '@/shared/lib/cn'

import type { HelpAccentColor } from '../data/helpCategories'

const ACCENT_BORDER: Record<HelpAccentColor, string> = {
  red: 'border-red',
  yellow: 'border-yellow',
  green: 'border-green',
  blue: 'border-blue',
  'yellow-soft': 'border-yellow-soft',
}

interface HelpArticleSectionProps {
  title: string
  accent: HelpAccentColor
  children: ReactNode
}

export function HelpArticleSection({ title, accent, children }: HelpArticleSectionProps) {
  return (
    <section
      className={cn(
        'mb-10 border-l-4 bg-card px-5 py-5 last:mb-0 sm:px-6 sm:py-6',
        ACCENT_BORDER[accent],
      )}
    >
      <h2 className="mb-3 font-display text-xl font-bold sm:text-2xl">{title}</h2>
      <div className="space-y-3 text-sm leading-relaxed text-foreground sm:text-base">
        {children}
      </div>
    </section>
  )
}
